<div cdkTrapFocus cdkTrapFocusAutoCapture>
  <ng-content></ng-content>
</div>

